function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 27.963,
  height: 25.963,
  transform: "translate(365.107 367.461)",
  fill: "#009fda"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "c"
}, /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 30
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "b",
  clipPath: "url(#c)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-364.107 -365.461)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M391.473,390.347a1.482,1.482,0,0,1-1.481,1.481H368.184a1.482,1.482,0,0,1-1.481-1.481V376.606a1.483,1.483,0,0,1,1.481-1.481h21.808a1.483,1.483,0,0,1,1.481,1.481Zm-14.95-16.818v-1.537a.2.2,0,0,1,.2-.141h4.724a.2.2,0,0,1,.2.141v1.537Zm-2.793-1.537a2.969,2.969,0,0,1,3-2.934h4.724a2.969,2.969,0,0,1,3,2.934v1.537h-1.2v-1.537a1.771,1.771,0,0,0-1.8-1.737h-4.724a1.771,1.771,0,0,0-1.8,1.737v1.537h-1.2Zm16.262,1.537h-3.95v-1.537a4.566,4.566,0,0,0-4.592-4.53h-4.724a4.566,4.566,0,0,0-4.592,4.53v1.537h-3.95a3.081,3.081,0,0,0-3.077,3.077v13.741a3.08,3.08,0,0,0,3.077,3.077h21.808a3.08,3.08,0,0,0,3.077-3.077V376.606a3.081,3.081,0,0,0-3.077-3.077",
  fill: "#009fda"
}), /*#__PURE__*/React.createElement("path", {
  d: "M379.01,388.173a4.7,4.7,0,1,1,4.7-4.7,4.7,4.7,0,0,1-4.7,4.7m0-10.989a6.293,6.293,0,1,0,6.292,6.292,6.292,6.292,0,0,0-6.292-6.292",
  fill: "#009fda"
})), /*#__PURE__*/React.createElement("path", {
  d: "M379.817,380.369H378.2v2.3h-2.3v1.615h2.3v2.3h1.615v-2.3h2.3v-1.615h-2.3Z",
  fill: "#009fda"
})));

var SvgPhysioCanTreat30Px = function SvgPhysioCanTreat30Px(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhysioCanTreat30Px, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PHYSIO_CAN_TREAT_30px.9845b7fc.svg";
export { ForwardRef as ReactComponent };